import { render, staticRenderFns } from "./water-really.vue?vue&type=template&id=50cbee4f&scoped=true&"
import script from "./water-really.vue?vue&type=script&lang=js&"
export * from "./water-really.vue?vue&type=script&lang=js&"
import style0 from "./water-really.vue?vue&type=style&index=0&id=50cbee4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cbee4f",
  null
  
)

export default component.exports